import { Phone } from "lucide-react";
import { openEnquiry } from "../../lib/api";

export function StickyBar() {
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-[#e1e2e5] px-3 py-2 flex gap-2"
      data-testid="mobile-sticky-bar">
      <a href="tel:+917042249097" data-testid="sticky-call"
        className="flex-1 min-h-[48px] rounded-full border-2 border-[#191c1f] font-bold grid place-items-center">
        <span className="flex items-center gap-2"><Phone size={18} /> Call</span>
      </a>
      <button data-testid="sticky-eligibility" onClick={() => openEnquiry({})}
        className="flex-[1.4] min-h-[48px] rounded-full bg-[#f06400] text-[#191c1f] font-extrabold">
        Check eligibility
      </button>
    </div>
  );
}
